import styled from '@emotion/styled';

const TitleBlue = styled.div`
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    background: var(--dark-blue);
    color: var(--white);
    padding: 8px 5px;
    border-radius: 5px;
    position: relative;
    padding-left: 20px;

    &::before {
        content: '';
        position: absolute;
        left: 10px;
        top: 50%;
        width: 4px;
        height: var(--font-large);
        background-color: var(--white);
        transform: translateY(-50%);
        border-radius: 2px;
    }
`;

export const SubTitleLabel: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    return <TitleBlue>{children}</TitleBlue>;
};
